export const getRuleDeductionProps = (selection) => {
    return {
        deductionText: selection.rule4Deduction || ""
    };
};
//# sourceMappingURL=getRuleDeductionProps.js.map